import { render, staticRenderFns } from "./orgTree.vue?vue&type=template&id=5d6250a4&scoped=true"
import script from "./orgTree.vue?vue&type=script&lang=js"
export * from "./orgTree.vue?vue&type=script&lang=js"
import style0 from "./orgTree.vue?vue&type=style&index=0&id=5d6250a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6250a4",
  null
  
)

export default component.exports